module.exports = __webpack_public_path__ + "img/appstore.628a1401.png";